import { Box, Text } from '@chakra-ui/react';
import { useMemo } from 'react';
import { useGlobalContext } from '../context/globalContext';
import { useAuth } from '../context/authContext';
import { Select } from './ui/select';

export default function SiteSwitcher({ collapsed }: { collapsed: boolean }) {
  const { user } = useAuth();
  const { siteName, isLoading, setSiteName } = useGlobalContext();

  const siteOptions = useMemo(() => (user?.sites ?? []).map(site => ({ label: site, value: site })), [user?.sites]);

  return (
    <Box
      bg='global.bg'
      color='global.fg'
      colorPalette='global'
      border='1px solid'
      borderColor='global.border'
      borderRadius='md'
      p={2}
    >
      {user?.sites && user.sites.length > 1 ? (
        <Select
          options={siteOptions}
          value={siteName}
          onValueChange={setSiteName}
          disabled={isLoading}
          label='Site'
          layout='form'
          width={collapsed ? '70px' : '150px'}
          size='md'
          appearance='sidebar'
        />
      ) : (
        <Text as='span'>Site: {siteName}</Text>
      )}
    </Box>
  );
}
